import {
  alterarSituacaoGrupo,
  alterarSituacaoSubgrupo,
  alterarSituacaoTipoObra,
} from "@/modules/financeiro-configuracoes";
import { TOASTS } from "./base-dados.constants";
import type { AlvoSituacao } from "./base-dados.linhas";

export function ativarAlvo(alvo: AlvoSituacao, idempotencyKey: string) {
  if (alvo.tipo === "tipo-obra") {
    return alterarSituacaoTipoObra(alvo.tipoObraId, "ATIVO", { idempotencyKey });
  }
  return alvo.tipo === "grupo"
    ? alterarSituacaoGrupo(alvo.grupoId, "ATIVO", { idempotencyKey })
    : alterarSituacaoSubgrupo(alvo.grupoId, alvo.subgrupoId, "ATIVO", { idempotencyKey });
}

export function avisoDaAtivacao(alvo: AlvoSituacao) {
  if (alvo.tipo === "tipo-obra") return TOASTS.tipoAtivado(alvo.codigo);
  if (alvo.tipo === "subgrupo") return TOASTS.subgrupoReativado(alvo.nome, alvo.grupoNome);
  return TOASTS.grupoReativado(alvo.nome, alvo.comSubgrupos);
}
